import {Endpoints} from '../../../../globals/api/endpoints';

export class VideoEndpoints extends Endpoints {

  public static readonly VIDEO = VideoEndpoints.VIEWER + '/video/' + VideoEndpoints.PROJECT_ID;
}
